/**
 * order-tracking.js — form tra cứu đơn (order-tracking.html, mục 27) bản DEMO.
 *
 * - Điền sẵn mã đơn + SĐT của đơn vừa đặt (localStorage `wb_last_order`, do checkout.js ghi)
 *   để khách bấm "Theo dõi đơn hàng" ở trang cảm ơn là thấy ngay đơn của mình.
 * - Bấm "Tra cứu": kiểm định dạng mã (WB + 8 số ngày + 4 số, vd WB20261021-0458; nhận cả
 *   mã ngắn WB1021 trong bảng đơn gần đây) và SĐT Việt Nam. Sai → lỗi dưới ô (.field--error).
 *   Đúng → hiện khối kết quả với mã vừa nhập. Bản tĩnh không có dữ liệu thật nên mọi mã đúng
 *   định dạng đều ra cùng một hành trình mẫu.
 * Form để novalidate và tự in lỗi: lỗi định dạng mã không diễn đạt được bằng thuộc tính HTML
 * mà vẫn ra câu tiếng Việt dễ hiểu.
 *
 * Markup cần: form[data-track-form] (#orderid, #order_phone, .field__error), [data-track-result],
 * [data-track-code].
 *
 * WP/WooCommerce: XOÁ — [woocommerce_order_tracking] POST thật rồi in tracking.php; có thể giữ
 * riêng hàm kiểm SĐT để báo lỗi sớm phía trình duyệt.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var form = document.querySelector('[data-track-form]');
    if (!form) return;

    var KEY_ORDER = 'wb_last_order';
    var CODE_RE = /^#?WB(?:\d{8}-\d{4}|\d{4})$/i;

    var codeInput = form.querySelector('#orderid');
    var phoneInput = form.querySelector('#order_phone');
    var submit = form.querySelector('[type="submit"]');
    var result = document.querySelector('[data-track-result]');
    var codeOut = document.querySelector('[data-track-code]');

    function normalizeCode(value) {
        return String(value || '').replace(/\s+/g, '').replace(/^#/, '').toUpperCase();
    }

    function phoneOk(value) {
        return /^(?:\+?84|0)(?:3|5|7|8|9)\d{8}$/.test(String(value).replace(/[\s.\-()]/g, ''));
    }

    function showError(input, message) {
        var field = input.closest('.field');
        var error = field ? field.querySelector('.field__error') : null;
        if (field) field.classList.toggle('field--error', !!message);
        if (error) {
            error.hidden = !message;
            error.textContent = message || '';
        }
        if (message) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
    }

    function validate() {
        var code = codeInput.value.trim();
        var phone = phoneInput.value.trim();
        var codeMsg = !code ? 'Vui lòng nhập mã đơn hàng.' : (CODE_RE.test(code.replace(/\s+/g, '')) ? '' : 'Mã đơn chưa đúng định dạng — ví dụ WB20261021-0458.');
        var phoneMsg = !phone ? 'Vui lòng nhập số điện thoại đặt hàng.' : (phoneOk(phone) ? '' : 'Số điện thoại chưa đúng (vd 0901 234 567).');
        showError(codeInput, codeMsg);
        showError(phoneInput, phoneMsg);
        if (codeMsg) codeInput.focus();
        else if (phoneMsg) phoneInput.focus();
        return !codeMsg && !phoneMsg;
    }

    function showResult(code) {
        if (codeOut) codeOut.textContent = '#' + code;
        if (!result) return;
        result.hidden = false;
        // Đưa focus tới tiêu đề kết quả: trình đọc màn hình đọc ngay trạng thái đơn
        var heading = result.querySelector('[tabindex="-1"]');
        if (heading) heading.focus({ preventScroll: true });
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!validate()) return;

        var code = normalizeCode(codeInput.value);
        codeInput.value = code;
        // Giả lập chờ server ~0,5 giây để nút quay vòng — đúng cảm giác của form thật
        submit.disabled = true;
        submit.classList.add('is-loading');
        window.setTimeout(function () {
            submit.disabled = false;
            submit.classList.remove('is-loading');
            showResult(code);
        }, 500);
    });

    // Sửa lại đúng thì gỡ lỗi ngay khi gõ, không bắt chờ bấm lần nữa
    form.addEventListener('input', function (event) {
        var input = event.target;
        if (input.getAttribute('aria-invalid') !== 'true') return;
        var ok = input === codeInput ? CODE_RE.test(input.value.replace(/\s+/g, '')) : phoneOk(input.value);
        if (ok) showError(input, '');
    });

    // Đơn vừa đặt trên máy này: điền sẵn và hiện luôn mã đó trong kết quả
    try {
        var last = JSON.parse(window.localStorage.getItem(KEY_ORDER) || 'null');
        if (last && last.number) {
            codeInput.value = last.number;
            if (last.customer && last.customer.phone) phoneInput.value = last.customer.phone;
            if (codeOut) codeOut.textContent = '#' + last.number;
        }
    } catch (e) {
        /* không đọc được thì giữ đơn mẫu */
    }
})();
